var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49988 1C4.49988 0.723858 4.27602 0.5 3.99988 0.5C3.72374 0.5 3.49988 0.723858 3.49988 1L3.49988 7.83332H2.09013C0.568757 7.83332 -0.290644 9.57944 0.637384 10.785L2.54715 13.2658C3.28103 14.2192 4.71875 14.2192 5.45263 13.2658L7.3624 10.785C8.29042 9.57944 7.43103 7.83332 5.90965 7.83332H4.49988V1ZM1.42979 10.175C1.00796 9.62701 1.3986 8.83332 2.09013 8.83332H3.99656L3.99988 8.83333L4.0032 8.83332H5.90965C6.60119 8.83332 6.99182 9.62701 6.56999 10.175L4.66023 12.6558C4.32664 13.0892 3.67314 13.0892 3.33955 12.6558L1.42979 10.175Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportArrow);
export default __webpack_public_path__ + "static/media/import-arrow.384455ddc9cf6710c5d711e1ed919745.svg";
export { ForwardRef as ReactComponent };